<template>
  <div class="xcard">
    <div v-if="cargado">
      <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
      >
      <h3 class="text-center" style="margin-bottom:0">{{ parsePrograma(programa) }}</h3>
      <p class="text-primary text-center" style="margin-top:0"><small> Detalle del programa. </small></p>
      <hr style="margin-top:0" />

      <b class="text-primary"><small>Postgrado:</small></b>
      <div class="row">
        <div class="col-sm-8">
          <p class="mb-0"><b>Objetivo: </b> {{ programa.postgrado.objetivo }}</p>
          <p class="mb-0"><b>Dirigido: </b> {{ programa.postgrado.dirigido }}</p>
        </div>
        <div class="col-sm-4">
          <p class="mb-0">
            <b>Duracion: </b> {{ programa.postgrado.duracion }} {{ parseUnidadDur(programa.postgrado.unidad_duracion) }}
          </p>
          <p class="mb-0"><b>Creditaje: </b> {{ programa.postgrado.creditaje }} Horas</p>
          <p class="mb-0"><b>Carga horaria: </b> {{ programa.postgrado.carga_horaria }} Horas</p>
          <p class="mb-0"><b>Area: </b> {{ programa.postgrado.area.nombre }}</p>
          <p class="mb-0"><b>Categoria: </b> {{ programa.postgrado.categoria.nombre }}</p>
        </div>
      </div>
      <v-divider class="my-0"></v-divider>

      <v-row>
        <v-col class="py-0" cols="12"> <p class="text-primary h4 mb-0">Programa:</p> </v-col>
        <v-col class="py-0" cols="12" sm="6" md="4" lg="3"
          ><p class="mb-0">
            <b>Version:</b> <span class="text-primary">{{ programa.version }}</span>
          </p></v-col
        >
        <v-col class="py-0" cols="12" sm="6" md="4" lg="3"
          ><p class="mb-0">
            <b>Grupo:</b> <span class="text-primary">{{ programa.grupo }}</span>
          </p></v-col
        >
        <v-col class="py-0" cols="12" sm="6" md="4" lg="3"
          ><p class="mb-0">
            <b>Fecha inicio:</b> <span class="text-primary">{{ parseFecha(programa.fecha_inicio) }}</span>
          </p></v-col
        >
        <v-col class="py-0" cols="12" sm="6" md="4" lg="3"
          ><p class="mb-0">
            <b>Finaliza:</b> <span class="text-primary">{{ parseFecha(programa.fecha_fin) }}</span>
          </p></v-col
        >
        <v-col class="py-0" cols="12" sm="6" md="4" lg="3"
          ><p class="mb-0">
            <b>Gestion:</b> <span class="text-primary">{{ programa.gestion }}</span>
          </p></v-col
        >
        <!-- <v-col class="py-0" cols="12" sm="6" md="4" lg="3"><p class="mb-0"> <b>Monto matricula:</b> <span class="text-primary">{{programa.monto_matricula}} Bs.</span> </p></v-col>
      <v-col class="py-0" cols="12" sm="6" md="4" lg="3"><p class="mb-0"> <b>Monto Colegiatura:</b> <span class="text-primary">{{programa.monto_colegiatura}} Bs.</span> </p></v-col>
      <v-col class="py-0" cols="12" sm="6" md="4" lg="3"><p class="mb-0"> <b>Monto Certificacion:</b> <span class="text-primary">{{programa.monto_certificacion}} Bs.</span> </p></v-col>
      <v-col class="py-0" cols="12" sm="6" md="4" lg="3"><p class="mb-0"> <b>Cuotas:</b> <span class="text-primary">{{programa.cuotas}}</span> </p></v-col> -->
        <v-col class="py-0" cols="12" sm="6" md="4" lg="3"
          ><p class="mb-0">
            <b>Fase:</b> <span class="text-primary">{{ parseFase(programa.fase) }}</span>
          </p></v-col
        >
        <v-col class="py-0" cols="12" sm="6" md="4" lg="3"
          ><p class="mb-0"><b>Mod. Finalizado:</b> {{ programa.mod_finalizado }}</p></v-col
        >
        <v-col class="py-0" cols="12" sm="6" md="4" lg="3"
          ><p class="mb-0">
            <b>Sede:</b> <span class="text-primary">{{ programa.sede.nombre }}</span>
          </p></v-col
        >
        <v-col class="py-0" cols="12" sm="6" md="4" lg="4"
          ><p class="mb-0">
            <b>Convenio:</b>
            <span class="text-primary">{{ programa.universidad ? programa.universidad.nombre : '-' }}</span>
          </p></v-col
        >
        <v-col class="py-0" cols="12" sm="6" md="4" lg="4"
          ><p class="mb-0">
            <b>Coordinador:</b> <span class="text-primary">{{ coordinador }}</span>
          </p></v-col
        >
        <v-col class="py-0" cols="12" sm="6" md="4" lg="4"
          ><p class="mb-0">
            <b>Responsable:</b> <span class="text-primary">{{ responsable }}</span>
          </p></v-col
        >
      </v-row>
      <div class="mt-3">
        <button class="btn btn-azul" :disabled="programa.fase >= 2" @click="abrirgeneradorEnlace()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-link-45deg mt-1"
            viewBox="0 0 16 16"
          >
            <path
              d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"
            />
            <path
              d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"
            />
          </svg>
          Obtener Mi Enlace de pre inscripcion
        </button>
        <p class="text-danger" v-if="programa.fase >= 2">
          El enlace de pre inscripcion solo esta disponible para cuando el programa esta en fase de inscripciones
        </p>
      </div>
      <hr />

      <div class="table-responsive">
        <table class="table table-condensed table-striped table-hover">
          <thead>
            <tr>
              <th>Nro</th>
              <th>Modulo</th>
              <th>CourseId</th>
              <th>Docente</th>
              <th>Inicio</th>
              <th>fin</th>
              <th>Opciones</th>
            </tr>
          </thead>

          <tbody>
            <tr v-bind:key="ind" v-for="(m, ind) in programa.programa_modulos">
              <td>{{ m.numero }}</td>
              <td :title="'ID:'+m.id">{{ m.modulo.nombre }}</td>
              <td>{{ m.course_id }}</td>
              <td>{{ parseDoce(m.docente) }}</td>
              <td>{{ parseFecha(m.inicio) }}</td>
              <td>{{ parseFecha(m.fin) }}</td>
              <td> 

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mx-2" tile dark small color="green" v-bind="attrs" v-on="on" @click="openOpcionesModulo(m,programa)">
                      <v-icon dark small>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Informacion del modulo</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <notifications group="auth" position="bottom right" />

      <modal id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
      <modald id="modald" v-bind:obj="seleccionadoD" v-on:exito="modalExitoD" />
      <div>
        <genenlace ref="generarenlace" />
      </div>
      <div>
        <psessiones ref="psessiones" />
      </div>
    </div>
    <p v-else class="text-center text-primary">Cargando...</p>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import { parseJsonError, error } from '@/components/Utils.js';
  import modal from '@/components/AAsignarCourseid.vue';
  import modald from '@/components/AAsignarDocente.vue';
  import genenlace from '@/components/AGenerarEnlace.vue';
  import psessiones from '@/components/APrograma-sessiones.vue';
  import xaxios from '@/xaxios'; 

  export default {
    data() {
      return {
        api_rest: process.env.VUE_APP_API_REST,
        msg: '',
        issessiondis: false,
        cargado: false,
        courseid: 0,
        seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
        seleccionadoD: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
        programa: {
          sede: {},
          postgrado: { categoria: {}, area: {} },
          universidad: {},
        },
        responsable: null,
        coordinador: null,
      };
    },
    components: { modal, modald, genenlace,psessiones },
    methods: {
        opensessiones(item){
          if( !this.issessiondis ){
            this.$notify(error('Denegado', 'Acceso denegado a esta opcion.'));
          }else{
            this.$refs.psessiones.openmodal(item);
          }
        }, 
      openOpcionesModulo(mod, prog){
        window.console.log('-----',mod,prog);
        let idmod = mod.modulo.id;
        let nombre = mod.modulo.nombre;
        let numero = mod.numero;
        let programa_modulo_id = mod.id; 
        let programa_id = this.programa.id;
        this.$router.push(`moduloopciones?modulo_id=${idmod}&nombre=${nombre}&numero=${numero}&programa_modulo_id=${programa_modulo_id}&programa_id=${programa_id}`);
      },
      verNotas(p) {
        window.sessionStorage.setItem('xmod', JSON.stringify(p));
        this.$router.push({ name: 'xnotas' });
      },
      parseDoce(d) {
        if (!d) return '---';
        if (!d.seg_apellido) d.seg_apellido = '';
        return d.nombres + ' ' + d.pri_apellido + ' ' + d.seg_apellido;
      },
      parseUnidadDur(u) {
        if (u == 0) return 'Meses';
        else if (u == 1) return 'Semanas';
        else if (u == 2) return 'Dias';
        else if (u == 3) return 'Horas';
        else return '?';
      },
      parsePrograma(p) {
        if (p == null) return '';
        return p.nombre_compuesto;
      },
      parseFecha(fe) {
        if (fe == null) return ' ';
        var vs = fe.split('-');
        return vs[2] + '/' + vs[1] + '/' + vs[0];
      },
      parseFase(fase) {
        if (fase == 1) return 'Inscripciones Abiertas';
        else if (fase == 2) return 'En Desarrollo';
        else if (fase == 3) return 'En Tramites';
        else if (fase == 4) return 'Finalizado/Cerrado';
        else 'Unknow';
      },
      modalExito() {
        this.getDatos();
      },
      modalExitoD() {
        //this.getDatos();
      },
      abrirgeneradorEnlace() {
        this.$refs.generarenlace.open(this.programa);
      },
      abrirAsignarDocente(mod) {
        var obj = mod.modulo;
        var msg = 'Asignar Docente al modulo';
        var body =
          'Para seleccionar un docente ingrese el nombre o documento del docente\n\n'; /*+this.programa.id+' '+obj.id*/
        this.seleccionadoD = { xid: obj.id, xidpro: this.programa.id, xtitle: msg, xbody: body, xsql: '' };
      },
      asigarCourseId(mod) {
        var obj = mod.modulo;
        var msg = 'Asignar Codigo de curso';
        var body =
          'Ingrese el codigo del curso, este codigo pertenece al modulo en la plataforma Moodle\n\n'; /*+this.programa.id+' '+obj.id*/
        this.seleccionado = { xid: obj.id, xidpro: this.programa.id, xtitle: msg, xbody: body, xsql: '' };
        // window.console.log( "Asignar Modulo course:\n",window.stringifyObject(mod) );
      },
      async getDatos() {
        if (this.programa == null) return;
        const vue = this;
        var sql = gql`query{ getPrograma(id:${this.programa.id}){id,version,nombre_compuesto,grupo,fecha_inicio,fecha_fin,gestion,postgrado{ objetivo,dirigido,duracion,unidad_duracion,creditaje,carga_horaria,programas{id},categoria{nombre},area{nombre} },sede{nombre unidad_negocio},fase,mod_finalizado,universidad{nombre},programa_modulos{id,course_id,modulo{	id,nombre},docente{nombres,pri_apellido,seg_apellido},numero,inicio,fin,puntuacion,estado}} }`;
        //var sql = gql`query{ getPrograma(id:${this.programa.id}){id,version,grupo,fecha_inicio,fecha_fin,gestion,postgrado{nombre,categoria{nombre}},sede{nombre},monto_matricula,monto_colegiatura,monto_certificacion,fase,cuotas,mod_finalizado,universidad{nombre},programa_modulos{modulo{	id,nombre},numero,inicio,fin,puntuacion,concluido}} }`;
        // window.console.log( sql )
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            vue.programa = data.data.getPrograma;
            //window.console.log( "GET PROGRMA::: ",JSON.stringify(vue.programa,null,4) )
            if (vue.programa == null) {
              vue.$notify(error('ERROR', 'getPrograma'));
              return;
            }

            vue.programa.programa_modulos.sort(function(a, b) {
              return a.numero - b.numero;
            });
            vue.cargado = true;
            vue.courseid = vue.programa.programa_modulos;
          })
          .catch((error) => {
            // window.console.log( error )
            vue.cargado = true;
            this.$notify(parseJsonError(error, 'getPrograma'));
          });

        let url = `${this.api_rest}/esam/programa/id/${this.programa.id}`;
        // var myHeaders = new Headers();
        // myHeaders.append("Content-Type", "application/json");
        // myHeaders.append("Authorization", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImNhcmdvcyI6WyIxIiwiMSIsIjEiLCIxIiwiMSIsIjEiLCIxIiwiMSIsIjEiLCIxIiwiMSIsIjEiLCIxIl0sImlhdCI6MTYxODIzNTY1NCwiZXhwIjoxNjE4MjM2NTU0fQ.xPKZ8FCfimRxA0XcvHjcmaNmUOrhuL7hCNRIuj2o-UY");

        // var requestOptions = { method: 'GET', headers: myHeaders,};
        // fetch(url, requestOptions)
        //   .then(response => response.json())
        //   .then(result => {
        //     window.console.log(result)
        //   })
        //   .catch(error => {window.console.log('error', error)});

        //window.console.log(url);
        await xaxios.get(url).then(({ data: { datos_coordinador, datos_responsable } }) => {
          //window.console.log(datos_coordinador, datos_responsable);
          if( datos_coordinador ){
            let { coordinador } = datos_coordinador;
            vue.coordinador =
              datos_coordinador && coordinador
                ? `${coordinador.nombres} ${coordinador.primer_apellido} ${coordinador.segundo_apellido}`
                : null;
          }
          if( datos_responsable ){
            let { responsable } = datos_responsable;
            vue.responsable =
              datos_responsable && responsable
                ? `${responsable.nombres} ${responsable.primer_apellido} ${responsable.segundo_apellido}`
                : null;
          }
        });
      },
    },
    mounted() {
      this.issessiondis = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 8 || this.$store.state.CARGO.id == 6 || this.$store.state.CARGO.id == 7;
      var xp = window.sessionStorage.xprograma;
      if (xp) {
        var p = JSON.parse(xp);
        if (p) {
          this.programa = p;
        }
      }
      this.getDatos();
    },
  };
</script>
